import { getChannelAPIPath } from '@treasury/core/http';

BillPayService.$inject = ['$resource'];

export default function BillPayService($resource) {
    return {
        getBillPayUrl,
    };

    function getBillPayUrl() {
        return $resource(`${getChannelAPIPath()}billpay/getbillpayurl`).get().$promise;
    }
}
